import * as dayjs from 'dayjs';
import * as localizedFormat from 'dayjs/plugin/localizedFormat';
import * as timezone from 'dayjs/plugin/timezone';
import * as utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);

export const defaultTimeZone = 'Australia/Sydney';

export const BrisbaneTimeZone = 'Australia/Brisbane';

export const unix = dayjs.unix;
export const tz = dayjs.tz;

export const now = () => dayjs().format();

export const utcNow = () => dayjs().utc().format();

export const fromUnixTimestamp = (unixTimestamp: number) =>
  dayjs(unixTimestamp * 1000).format();

export const qldDate = (date: string) =>
  dayjs.tz(date, BrisbaneTimeZone).format('ll');

export const qldDateTime = (date: string) =>
  dayjs.tz(date, BrisbaneTimeZone).format('lll');

export const qldStartDateUTC = (date: string) =>
  dayjs.tz(date, BrisbaneTimeZone).clone().startOf('day').utc();

export const qldEndDateUTC = (date: string) =>
  dayjs.tz(date, BrisbaneTimeZone).clone().endOf('day').utc();

export const qldTime = () => dayjs().tz(BrisbaneTimeZone);

export const qldTimeNow = () =>
  dayjs().tz(BrisbaneTimeZone).format().split('+')[0];
